import { GroupResultProps, ResultProps } from "../../api/types";
import React, { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import Button, { ButtonProps } from "@mui/material/Button";
import {
	Alert,
	Dialog,
	DialogActions,
	DialogTitle,
	Snackbar,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import SendIcon from "@mui/icons-material/Send";
import { styled } from "@mui/material/styles";
import LoadingButton from "@mui/lab/LoadingButton";
import { GroupResultTemplate } from "helpers/generatePDF/GroupResultPDF/GroupResultTemplate";

interface DownloadDialogProps {
	loading: boolean;
	baseName: string;
	resultToBeRendered: ResultProps;
}

export const GroupDownloadDialog: React.FC<DownloadDialogProps> = ({
	loading,
	baseName,
	resultToBeRendered,
}): JSX.Element => {
	const [open, setOpen] = useState(false);
	const [email, setEmail] = useState(false);

	const handleClickOpen = (): void => {
		setOpen(true);
	};

	const handleClose = (): void => {
		setOpen(false);
	};

	const handleClickEmail = (): void => {
		setEmail(true);
		setOpen(false);
	};

	const handleClickDownload = async (): Promise<void> => {
		setOpen(false);
		const blob: Blob = await pdf(
			<GroupResultTemplate data={resultToBeRendered as GroupResultProps} />,
		).toBlob();
		saveAs(blob, baseName);
	};

	return (
		<div>
			<div>
				<DownloadDialogButton
					variant="contained"
					onClick={handleClickOpen}
					loading={loading}
					loadingIndicator="Loading..."
				>
					DOWNLOAD
				</DownloadDialogButton>
				<Dialog
					open={open}
					onClose={handleClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">
						{"Confirm to start downloading the report"}
					</DialogTitle>
					<DialogActions>
						<ColoredButton
							size="small"
							variant="contained"
							onClick={handleClickDownload}
							endIcon={<SaveIcon />}
							autoFocus
						>
							Save as PDF
						</ColoredButton>

						<ColoredButton
							size="small"
							variant="contained"
							onClick={handleClickEmail}
							endIcon={<SendIcon />}
						>
							Send to My Email
						</ColoredButton>
					</DialogActions>
				</Dialog>
			</div>
			<div>{email ? <DevelopingAlert /> : null}</div>
		</div>
	);
};

const DownloadDialogButton = styled(LoadingButton)<ButtonProps>(
	({ theme }) => ({
		color: theme.palette.getContrastText("#025ddc"),
		backgroundColor: "#025ddc",
		"&:hover": {
			backgroundColor: "#0247a8",
		},
	}),
);

const ColoredButton = styled(Button)<ButtonProps>(({ theme }) => ({
	color: theme.palette.getContrastText("#025ddc"),
	backgroundColor: "#025ddc",
	"&:hover": {
		backgroundColor: "#0247a8",
	},
}));

const DevelopingAlert = (): JSX.Element => {
	const [alert, setAlert] = useState(true);
	return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "center" }}
			onClose={() => setAlert(false)}
			open={alert}
			autoHideDuration={1000}
		>
			<Alert elevation={6} variant="filled" severity={"warning"}>
				Not implemented yet.
			</Alert>
		</Snackbar>
	);
};
